/**
* GENERATED BY KRPC GEN - LESS MODIFY BY HAND
* tech-service.ts  2026-08-26T09:15:21+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'krpc-base';

import type { TechTrainingCert, TechServiceTime } from './wy-dto';

const _ = 'Tech/';

export class TechService {

  constructor(readonly r: RpcService) {}
  // 技师的最近3个培训证书，按发证时间由新到旧
  getLast3TrainingCert(d:string, m?: M): R<Array<TechTrainingCert>>{
    return this.r.async(_ + 'getLast3TrainingCert', d, m);
  }
  // 获取指定技师的服务时间列表
  getTechServiceTime(d:string, m?: M): R<Array<TechServiceTime>>{
    return this.r.async(_ + 'getTechServiceTime', d, m);
  }
}
